import React, { useState, FormEvent } from 'react';
import {
    Box,
    Typography,
    Paper,
    Button,
    CircularProgress
} from '@mui/material';

interface Rule {
  content: string;
}

interface Faq {
  id: number;
  question: string;
  answer: string;
}

interface ContentTabProps {
    apiFetch: (url: string, options?: RequestInit) => Promise<any>;
    handleApiCall: (apiCall: Promise<any>, successMessage: string) => Promise<void>;
    rule: Rule;
    setRule: (rule: Rule) => void;
    faqs: Faq[];
    loadingRule: boolean;
    loadingFaqs: boolean;
}

const ContentTab: React.FC<ContentTabProps> = ({
    apiFetch,
    handleApiCall,
    rule,
    setRule,
    faqs,
    loadingRule,
    loadingFaqs
}) => {
    const [ruleSaveLoading, setRuleSaveLoading] = useState(false);

    const handleRuleSave = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setRuleSaveLoading(true);
        const content = new FormData(e.currentTarget).get('content') as string;
        try {
            await handleApiCall(
                apiFetch('/rule/', { method: 'PUT', body: JSON.stringify({ content }) }),
                'قوانین با موفقیت به‌روز شد.'
            );
        } finally {
            setRuleSaveLoading(false);
        }
    };

    const handleAddFaq = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
        handleApiCall(
            apiFetch('/faqs/', {
                method: 'POST',
                body: JSON.stringify(Object.fromEntries(new FormData(form)))
            }),
            'سوال جدید اضافه شد.'
        ).then(() => {
            form.reset();
        });
    };

    const handleDeleteFaq = (faqId: number) => {
        handleApiCall(
            apiFetch(`/faqs/${faqId}`, { method: 'DELETE' }),
            'سوال حذف شد.'
        );
    };

    return (
        <>
            <Paper component="form" className="management-card rules-form-container" onSubmit={handleRuleSave}>
                <h3 className="tab-section-header">مدیریت قوانین</h3>
                <textarea
                    name="content"
                    value={rule.content || ''}
                    onChange={(e) => setRule({ ...rule, content: e.target.value })}
                    className="rules-textarea"
                    placeholder={loadingRule ? 'در حال بارگذاری قوانین...' : 'قوانین را اینجا وارد کنید'}
                />
                <Button type="submit" variant="contained" sx={{ alignSelf: 'flex-start' }} disabled={ruleSaveLoading}>
                    {ruleSaveLoading ? <CircularProgress size={24} /> : 'ذخیره قوانین'}
                </Button>
            </Paper>

            <Paper className="management-card">
                <h3 className="tab-section-header">مدیریت سوالات متداول</h3>
                {loadingFaqs ? (
                    <CircularProgress />
                ) : (
                    faqs.map(faq => (
                        <Box key={faq.id} sx={{ mb: 2, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                            <p><b>{faq.question}</b></p>
                            <p>{faq.answer}</p>
                            <Button color="error" size="small" onClick={() => handleDeleteFaq(faq.id)}>
                                حذف
                            </Button>
                        </Box>
                    ))
                )}
                <form onSubmit={handleAddFaq}>
                    <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
                        افزودن سوال جدید
                    </Typography>
                    <div className="simple-input-group">
                        <label>سوال</label>
                        <input type="text" name="question" required />
                    </div>
                    <div className="simple-input-group">
                        <label>پاسخ</label>
                        <textarea name="answer" rows={3} required></textarea>
                    </div>
                    <Button type="submit" variant="contained">
                        افزودن
                    </Button>
                </form>
            </Paper>
        </>
    );
};

export default ContentTab;